import { YesNoEnum } from '../HouseholdOutgoings/types';
import { TITLE_OPTIONS } from './types';

export const fullNameQuestions: Record<string, any> = {
  title: {
    labelKey: 'applicationForm.FULL_NAME.titleAndFirstName.label',
    options: TITLE_OPTIONS.map(option => ({ label: option, value: option })),
  },
  firstName: {
    labelKey: 'applicationForm.FULL_NAME.titleAndFirstName.label',
    explanationKey: 'applicationForm.FULL_NAME.titleAndFirstName.explanation',
  },
  lastName: {
    labelKey: 'applicationForm.FULL_NAME.surname.label',
    explanationKey: 'applicationForm.FULL_NAME.surname.explanation',
  },
  isNameChanged: {
    labelKey: 'applicationForm.FULL_NAME.isNameChanged.label',
    options: [
      { labelKey: 'common.yes', value: YesNoEnum.YES },
      { labelKey: 'common.no', value: YesNoEnum.NO },
    ],
  },
};
